<template>
  <div>
    <b-table
      v-if="transactions.length && !isLoadingTransactions"
      :items="transactions"
      :fields="tableColumns"
      :tbody-tr-class="rowClass"
      primary-key="id"
      :sort-by.sync="isSortBy"
      :sort-desc.sync="isSortDir"
      class="position-relative mb-0"
    >
      <template #cell()="data">
        <span class="text-nowrap">
          {{ data.value}}
        </span>
      </template>
    </b-table>
    <div class="text-center my-2" v-else-if="isLoadingTransactions">
      <b-spinner class="align-middle"></b-spinner>
      <strong> Cargando Saldo de Beneficios</strong>
    </div>
    <div v-else>
      <b-alert variant="warning" :show="true" class="mb-0">
        <div class="alert-body"> <feather-icon icon="InfoIcon" class="mr-50" />
          <span>Haga una busqueda mediante el filtro</span>
        </div>
      </b-alert>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { utils } from "@/modules/fivesClub/mixins/utils"


export default {
  mixins: [utils],
  props: {
    transactions: {
      type: Array,
      required: false,
    },
    tableColumns: {
      type: Array,
      required: true,
    },
    sortBy: {
      type: String,
      required: true,
    },
    isSortDirDesc: {
      type: Boolean,
      required: true,
    },
    isLoadingTransactions: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      isSortDir: this.isSortDirDesc,
      isSortBy: this.sortBy,
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState('fivesClubCatalogs', ['filter']),   
  },
};
</script>

<style lang="scss" >
@media (max-width: 1280px) {
  .mb-0.table-responsive {
    max-height: 369px;
  }
  .table-responsive th  {
    padding: 10px 10px 10px 10px !important;
    font-size: 10px;
  }
  .table-responsive th div {
    font-size: 10px;
  }
  .table-responsive td {
    padding: 5px !important;
    font-size: 9px;
  }
  .buttonInfo button{
    padding: 9px;
  }
  .buttonInfo {
    display: table-cell;
  }
  .isCentered{
    align-content: center;
    align-items: center;
  }
  .isSpinner{
    padding: 2rem;
  }
}
</style>
